import { Component, EventEmitter, forwardRef, HostBinding, HostListener, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'md-checkbox',
  templateUrl: './md-checkbox.component.html',
  styleUrls: ['./md-checkbox.component.scss'],
  providers: [
    {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MdCheckboxComponent),
        multi: true,
    },
  ],
})
export class MdCheckboxComponent implements ControlValueAccessor {
  

  @Input() color: "primary" | "primary-stroked" | "primary-text" | "primary-opacity" | "accent" | "accent-stroked" | "accent-text" | "accent-opacity" | "warn" | "warn-stroked" | "warn-text" | "warn-opacity";
  @Input() type = '';
  @Output() change = new EventEmitter();

  _value: boolean;
  get value() {
    return this._value;
  }
  set value(value){
    this._value=value;
    this.onChange(this._value)
  }
  disabled: boolean;
  onChange(_: any) {}
  onTouched = () => {};

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  writeValue(value: boolean) {
    this.value = value;
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

}


